"use strict";

module.exports = {
  SCANNING: 'SCANNING',
  VERIFYING: 'VERIFYING',
  CLOSED: 'CLOSED'
};